import { Component } from '@angular/core';
import { Breadcrumb } from './breadcrumb.model';
import { BreadcrumbService } from '../../services/breadcrumbs.service';
import { SvgIcon } from '@valg-shared/utils/svg-icon';
import { Title } from '@angular/platform-browser';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'valg-dk-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: [ './breadcrumbs.component.scss' ]
})
export class BreadcrumbsComponent {
  breadcrumbs?: Breadcrumb[];
  public previousBreadcrumb?: Breadcrumb;

  SvgIcon = SvgIcon;

  constructor(
    readonly breadcrumbService: BreadcrumbService,
    private readonly titleService: Title,
    private readonly translateService: TranslateService,)
  {
    breadcrumbService.breadcrumbs$.subscribe(result => {
      this.breadcrumbs = result;
      if(result.length > 1){
        this.previousBreadcrumb = result[result.length - 2];
        
        // set the title for pages with breadcrumbs. Other pages' titles are set in translate-title-strategy.ts.
        if (!this.breadcrumbs[1].label.includes("frontpage")) {
          const pageTitle = this.breadcrumbs[1].label;
          this.translateService.get('title').subscribe(solutionTitle => { this.titleService.setTitle(pageTitle + " - " + solutionTitle) })
        }
      }
    });
  }
}
